import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Dashboard/Home.vue";
import Produto from "../views/Produto/Produto.vue";
import Login from "../views/Login/Login.vue";
import MeuPerfil from "../views/Perfil/MeuPerfil.vue";
import DadosCadastrais from "../views/Perfil/DadosCadastrais.vue";
import MeuPlano from "../views/Perfil/MeuPlano.vue";
import Downloads from "../views/Perfil/Downloads.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/zapier-bot",
    name: "zapierbot",
    component: () =>
      import(
      /* webpackChunkName: "zapierbot" */ "../views/Produto/ZapierBot.vue"
      ),
  },
  {
    path: "/",
    name: "Dashboard",
    component: Home,
    meta: {
      login: true,
    },
  },
  {
    path: "/aceite",
    name: "Aceite",
    component: () =>
      import(/* webpackChunkName: "aceite" */ "../views/Temp/Aceite.vue"),
    meta: {
      login: true,
    },
  },
  {
    path: "/ajuda",
    name: "ajuda",
    component: () =>
      import(/* webpackChunkName: "ajuda" */ "../views/Ajuda/Ajuda.vue"),
    meta: {
      login: true,
    },
  },
  {
    path: "/noticias",
    name: "noticias",
    component: () =>
      import(
        /* webpackChunkName: "noticias" */ "../views/Noticias/Noticias.vue"
      ),
    meta: {
      login: true,
    },
  },
  {
    path: "/relatorio",
    name: "relatorios",
    meta: {
      login: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "relatorios" */ "../views/Produto/Relatorio.vue"
      ),
    children: [
      {
        path: "cheque-ressarcido",
        name: "chequeressarcido",
        component: () =>
          import(
            /* webpackChunkName: "chequeressarcido" */ "../views/Produto/ChequeRessarcido.vue"
          ),
      },
      {
        path: "cheque-garantido",
        name: "chequegarantido",
        component: () =>
          import(
            /* webpackChunkName: "chequegarantido" */ "../views/Produto/ChequeGarantido.vue"
          ),
      },
      {
        path: "cheque-recuperacao",
        name: "chequerecuperacao",
        component: () =>
          import(
            /* webpackChunkName: "chequerecuperacao" */ "../views/Produto/ChequeRecuperacao.vue"
          ),
      },
    ],
  },
  {
    path: "/visualizar-relatorio/:tipo/:periodo",
    name: "visualizar-relatorio",
    component: () =>
      import(
        /* webpackChunkName: "ajuda" */ "../views/Produto/VisualizarRelatorio.vue"
      ),
    meta: {
      login: true,
    },
  },
  {
    path: "/extrato-utilizacao-unimed/:periodo",
    name: "extrato-utilizacao-unimed",
    component: () =>
      import(
        /* webpackChunkName: "ajuda" */ "../views/Produto/Relatorio/ExtratoUtilizacaoUnimed.vue"
      ),
    meta: {
      login: true,
    },
  },
  {
    path: "/extrato-utilizacao_beneficiario/:periodo",
    name: "extrato-utilizacao_beneficiario",
    component: () =>
      import(
        /* webpackChunkName: "ajuda" */ "../views/Produto/Relatorio/ExtratoUtilizacao_Beneficiario.vue"
      ),
    meta: {
      login: true,
    },
  },
  {
    path: "/demonstrativo-faturamento/:periodo",
    name: "demonstrativo-faturamento",
    component: () =>
      import(
        /* webpackChunkName: "ajuda" */ "../views/Produto/DemonstrativoFaturamento.vue"
      ),
    meta: {
      login: true,
    },
  },
  {
    path: "/cdl-ead",
    name: "ead",
    meta: {
      login: true,
    },
    component: () =>
      import(/* webpackChunkName: "cdlead" */ "../views/Produto/CdlEad.vue"),
    children: [
      {
        path: "meus-cursos",
        name: "meuscursos",
        component: () =>
          import(
            /* webpackChunkName: "chamados" */ "../views/Perfil/MeusCursos.vue"
          ),
      },
      {
        path: "minhas-faturas",
        name: "faturasEad",
        component: () =>
          import(
            /* webpackChunkName: "chamados" */ "../views/Perfil/FaturasEad.vue"
          ),
      },
    ],
  },
  {
    path: "/produto",
    name: "produto",
    component: Produto,
    props: true,
    meta: {
      login: true,
    },
    children: [
      {
        path: "centroConvencoes",
        name: "centroConvencoes",
        component: () =>
          import(/* webpackChunkName: "spc" */ "../views/Produto/CentroConvencoes.vue"),
      },
      {
        path: "spc",
        name: "spc",
        component: () =>
          import(/* webpackChunkName: "spc" */ "../views/Produto/Spc.vue"),
      },
      {
        path: "spc-operadores",
        name: "operadores",
        component: () =>
          import(
            /* webpackChunkName: "operadores" */ "../views/Produto/OperadoresSPC.vue"
          ),
      },
      {
        path: "sos-solucoes",
        name: "sossolucoes",
        component: () =>
          import(
            /* webpackChunkName: "sossolucoes" */ "../views/Produto/SosSolucoes.vue"
          ),
      },
      {
        path: "apuracao-de-fatura",
        name: "apuracaodefatura",
        component: () =>
          import(
            /* webpackChunkName: "apuracao" */ "../views/Produto/ApuracaoFatura.vue"
          ),
      },
      {
        path: "cdl-parcerias",
        name: "cdlparcerias",
        component: () =>
          import(/* webpackChunkName: "leads" */ "../views/Produto/Leads.vue"),
      },
      {
        path: "2-via-boleto",
        name: "2viaboleto",
        component: () =>
          import(
            /* webpackChunkName: "boleto" */ "../views/Produto/Boleto.vue"
          ),
      },
      {
        path: "calculos",
        name: "calculos",
        component: () =>
          import(
            /* webpackChunkName: "calculos" */ "../views/Produto/Calculo.vue"
          ),
      },
      {
        path: "epraja",
        name: "epraja",
        component: () =>
          import(
            /* webpackChunkName: "consultoria" */ "../views/Produto/CDLConsultoria.vue"
          ),
      },
      {
        path: "cdl-saude-plano",
        name: "cdlsaudeplano",
        meta: {
          login: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "cdlsaude" */ "../views/Produto/CdlSaude/CdlSaude.vue"
          ),
        children: [
          {
            path: "listavidas",
            name: "listavidas",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/ListaVidas.vue"
              ),
          },
          {
            path: "cadastro/:cpfTitular?",
            name: "cadastrovidas",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/Cadastro.vue"
              ),
          },
          {
            path: "planos",
            name: "planos",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/Planos.vue"
              ),
          },
          {
            path: "finalizar-cadastro/:cpfTitular?",
            name: "finalizarcadastro",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/CadastroFinal.vue"
              ),
          },
          {
            path: "conferencia_dados",
            name: "resumo",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/Resumo.vue"
              ),
          },
          {
            path: "documentos/:cpfTitular",
            name: "arquivos",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/Arquivos.vue"
              ),
          },
          {
            path: "termo-aceite",
            name: "termo-aceite",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/CdlSaude/Termo.vue"
              ),
          },
          {
            path: "pagamento/:cpfTitular",
            name: "pagamento",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/Pagamento.vue"
              ),
          },
          {
            path: "alterarPlano/:cpfVida",
            name: "alterarplano",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/AlterarPlano.vue"
              ),
          },
          {
            path: "trocaracomodacao/:codVida",
            name: "trocaracomodacao",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/TrocarAcomodacao.vue"
              ),
          },
          {
            path: "pagamentoacomodacao",
            name: "pagamentoacomodacao",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/TrocaAcomodacaoPagamento.vue"
              ),
          },
          {
            path: "cancelamento/:codVida",
            name: "cancelamento",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/Cancelamento.vue"
              ),
          },
          {
            path: "opcional/:codVida",
            name: "opcional",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/Opcional.vue"
              ),
          },
          {
            path: "pagamentoopcional",
            name: "pagamentoopcional",
            component: () =>
              import(
                /* webpackChunkName: "ajuda" */ "../views/Produto/CdlSaude/TrocaOpcionalPagamento.vue"
              ),
          },
        ],
      },
      {
        path: "cdl-saude",
        name: "cdlsaude",
        meta: {
          login: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "cdlsaude" */ "../views/Produto/CdlSaude.vue"
          ),
        children: [
          {
            path: "2-via-cartao",
            name: "2viacartao",
            component: () =>
              import(
                /* webpackChunkName: "relsaude" */ "../views/Produto/2ViaCartao.vue"
              ),
          },
          {
            path: "relatorio-informativoA",
            name: "relatorioInformativoPagAtual",
            component: () =>
              import(
                /* webpackChunkName: "relsaude" */ "../views/Produto/RelatorioInformativoPagAtual.vue"
              ),
          },
          {
            path: "relatorio-unimed",
            name: "relatoriosaude",
            component: () =>
              import(
                /* webpackChunkName: "relsaude" */ "../views/Produto/RelatorioSaude.vue"
              ),
          },
          {
            path: "relatorio_utilizacaoxbeneficiario",
            name: "relatorioutilizacaoxbeneficiario",
            component: () =>
              import(
                /* webpackChunkName: "relsaude" */ "../views/Produto/Relatorio_UtilizacaoxBeneficiario.vue"
              ),
          },
          {
            path: "carta-carencia",
            name: "cartacarencia",
            component: () =>
              import(
                /* webpackChunkName: "carencia" */ "../views/Produto/CartaCarencia.vue"
              ),
          },
        ],
      },
      {
        path: "cdl-varejo-inteligente",
        name: "cdlvarejointeligente",
        meta: {
          login: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "cdlsaude" */ "../views/Produto/VarejoInteligente/VarejoInteligente.vue"
          ),
        children: [
          {
            path: "painel",
            name: "varejo",
            meta: {
              naoAssociado: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/Painel.vue"
              ),
          },
          {
            path: "produtos",
            name: "produtos",
            meta: {
              naoAssociado: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/ListaProdutos.vue"
              ),
          },
          {
            path: "formulario/:tipoProduto/:idAgenda",
            name: "formulario",
            meta: {
              naoAssociado: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/Formulario.vue"
              ),
          },
          {
            path: "agenda",
            name: "agenda",
            meta: {
              naoAssociado: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/Agenda.vue"
              ),
          },
          {
            path: "pagamento",
            name: "pagamentoVarejo",
            meta: {
              naoAssociado: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/Pagamento.vue"
              ),
          },
          {
            path: "estacao-trabalho/:idAgenda",
            name: "estacaoTrabalho",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/EstacaoTrabalho.vue"
              ),
          },
          {
            path: "formulario-estacao-trabalho/:idAgenda/:tipoReserva?",
            name: "formularioEstacaoTrabalho",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/FormularioEstacaoTrabalho.vue"
              ),
          },
          {
            path: "termo",
            name: "termoVarejo",
            meta: {
              naoAssociado: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/VarejoInteligente/Termo.vue"
              ),
          },
        ],
      },
      {
        path: "ponto-cultural",
        name: "pontoCultural",
        component: () =>
          import(
            /* webpackChunkName: "sossolucoes" */ "../views/Produto/PontoCultural.vue"
          ),
      },
      {
        path: "clube-vantagens",
        name: "clubeVantagens",
        component: () =>
          import(
            /* webpackChunkName: "sossolucoes" */ "../views/Produto/ClubeVantagens/ClubeVantagens.vue"
          ),
        children: [
          {
            path: "painel",
            name: "clube-painel",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/Painel.vue"
              ),
          },
          {
            path: "produtos",
            name: "clube-produtos",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/ListaProdutos.vue"
              ),
          },
          {
            path: "formulario/:tipoProduto",
            name: "formularioClube",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/Formulario.vue"
              ),
          },
          {
            path: "termo",
            name: "clube-termo",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/Termo.vue"
              ),
          },
          {
            path: "envio-imagens",
            name: "uploadClube",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/Arquivos.vue"
              ),
          },
          {
            path: "cancelamento",
            name: "cancelamentoClube",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/Retencao.vue"
              ),
          },
          {
            path: "remover-usuarios",
            name: "cancelamentoUsuarios",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/ClubeVantagens/CancelarUsuarios.vue"
              ),
          },
        ],
      },
      {
        path: "spc-conciliador",
        name: "spcConciliador",
        component: () =>
          import(
            /* webpackChunkName: "sossolucoes" */ "../views/Produto/ClubeVantagens/ClubeVantagens.vue"
          ),
        children: [
          {
            path: "painel",
            name: "painel-conciliador",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Conciliador/Painel.vue"
              ),
          },
          {
            path: "institucional",
            name: "institucional",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Conciliador/Institucional.vue"
              ),
          },
          {
            path: "planos",
            name: "planos-conciliador",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Conciliador/Planos.vue"
              ),
          },
          {
            path: "resumo",
            name: "resumo-conciliador",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Conciliador/Resumo.vue"
              ),
          },
          {
            path: "termo",
            name: "termo-conciliador",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Conciliador/Termo.vue"
              ),
          },
          {
            path: "pagamento",
            name: "pagamento-conciliador",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Conciliador/Pagamento.vue"
              ),
          },
        ],
      },
      {
        path: "carta-declaracao",
        name: "carta-declaracao",
        component: () =>
          import(
            /* webpackChunkName: "sossolucoes" */ "../views/Produto/CartaDeclaracao/Formulario.vue"
          ),
      },
      {
        path: "cdl-consultor",
        name: "cdlConsultor",
        component: () =>
          import(
            /* webpackChunkName: "sossolucoes" */ "../views/Produto/Consultor/Consultor.vue"
          ),
        children: [
          {
            path: "minha-carteira",
            name: "gerenciarAssociados",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/Painel.vue"
              ),
          },
          {
            path: "nova-filiacao",
            name: "solicitarFiliacao",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/SolicitarFiliacao.vue"
              ),
          },
          {
            path: "filiacao",
            name: "filiacao",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/Filiacao.vue"
              ),
          },
          {
            path: "arquivos",
            name: "consultorArquivos",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/Arquivos.vue"
              ),
          },
          {
            path: "editar-associado",
            name: "editarAssociado",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/AtualizarDadosCadastro.vue"
              ),
          },
          {
            path: "painel-associado",
            name: "painelAssociado",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/ListaAcoes.vue"
              ),
          },
          {
            path: "chamados",
            name: "consultor-chamados",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/Chamados.vue"
              ),
          },
          {
            path: "cdl-saude",
            name: "cdl-saude",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/CdlSaude.vue"
              ),
          },
          {
            path: "cdl-saude-cadastro",
            name: "cdl-saude-cadastro",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/CdlSaudeCadastro.vue"
              ),
          },
          {
            path: "cdl-saude-planos",
            name: "cdl-saude-planos",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/CdlSaudePlanos.vue"
              ),
          },
          {
            path: "cdl-saude-finalizar-cadastro/:cpfTitular?",
            name: "cdl-saude-finalizar-cadastro",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/CdlSaudeCadastroFinal.vue"
              ),
          },
          {
            path: "cdl-saude-resumo",
            name: "cdl-saude-resumo",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/CdlSaudeResumo.vue"
              ),
          },
          {
            path: "cdl-saude-documentos/:cpfTitular",
            name: "cdl-saude-arquivos",
            component: () =>
              import(
                /* webpackChunkName: "vida" */ "../views/Produto/Consultor/CdlSaudeArquivos.vue"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/login/:recuperarSenha?",
    name: "login",
    component: Login,
    props: true,
  },
  {
    path: "/meu-perfil",
    name: "perfil",
    component: MeuPerfil,
    props: true,
    meta: {
      login: true,
    },
    children: [
      {
        path: "",
        name: "meuperfil",
        component: DadosCadastrais,
      },
      {
        path: "meu-plano",
        name: "meuplano",
        component: MeuPlano,
      },

      {
        path: "downloads",
        name: "downloads",
        component: Downloads,
      },
      {
        path: "chamados",
        name: "meuschamados",
        component: () =>
          import(
            /* webpackChunkName: "chamados" */ "../views/Perfil/Chamados.vue"
          ),
      },
      {
        path: "atualizar-senha",
        name: "resetsenha",
        component: () =>
          import(
            /* webpackChunkName: "chamados" */ "../views/Perfil/ResetSenha.vue"
          ),
      },
    ],
  },
  {
    path: "/cadastro",
    name: "cadastroNaoAssociado",
    component: () =>
      import(
        /* webpackChunkName: "chamados" */ "../views/NaoAssociado/Cadastro.vue"
      ),
    props: true,
  },
  {
    path: "/login-visitante",
    name: "loginNaoAssociado",
    component: () =>
      import(
        /* webpackChunkName: "chamados" */ "../views/NaoAssociado/Login.vue"
      ),
    props: true,
  },
  {
    path: "/termo",
    name: "termoAssociado",
    component: () =>
      import(
        /* webpackChunkName: "chamados" */ "../views/Produto/Consultor/Termo.vue"
      ),
    props: true,
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () =>
      import(
        /* webpackChunkName: "chamados" */ "../views/Commons/PageNotFound.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "router-link-exact-active active",
  routes,
  scrollBehavior() {
    return window.scrollTo({ top: 0, behavior: "smooth" });
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.login)) {
    if (!window.sessionStorage.token) {
      next("/login");
    } else {
      if (to.matched.some((record) => record.meta.naoAssociado)) {
        next();
      } else {
        const userData = JSON.parse(sessionStorage.userData);
        if (!userData.naoAssociado) {
          next();
        } else {
          router.push({ name: "varejo" });
        }
      }
    }
  } else {
    next();
  }
});

export default router;
